// extracted by mini-css-extract-plugin
module.exports = {"base":"CopiedGithubMarkdownMessage_base__EiS7p","default":"CopiedGithubMarkdownMessage_default__Bd8yc","upper":"CopiedGithubMarkdownMessage_upper__L8odz"};